import { Spin, theme } from 'antd'
import { Title } from 'components'

import { useStore } from '@sar/framework/hooks'
import { useRequest, clearCache } from 'ahooks'

export default (Target: React.FC<any>) => function (props) {
  const store = useStore()
  const themeConfig = theme.useToken()

  const res = useRequest<any, any>(() => store.externals.api.get('/menu/my'), {
    ready: store.identity.isLogined(),
    staleTime: -1,
    cacheTime: -1,
    cacheKey: `/menu/my`,
  })

  const getConstant = useRequest<any, any>(() => store.externals.api.get(`/constant/all`).then(R.groupBy(R.prop<any>('status'))).then(result => {
    Object.keys(result).forEach(type => {
      Object.assign(store.config.constants, {
        [ type.charAt(0).toLocaleUpperCase() + type.slice(1) ]: result[type].map(data => ({
          value: data.source,
          description: data.source,
        }))
      })
    })
  }), {
    ready: store.identity.isLogined(),
    staleTime: -1,
    cacheTime: -1,
    cacheKey: `/constant/all`,
  })

  useRequest(() => store.externals.api.get(`/role/user/${store.identity.uid}`).then(roles => {
    const getChildren = (data) => {
      return data.children == null
        ? [ data ]
        : [ data, data.children.map(getChildren) ]
    }

    let getPermissions = R.compose(
      R.filter(R.compose(R.not, R.isNil)),
      R.map(R.prop('permission')),
      R.flatten,
    )

    store.identity.dispatch('user', Object.assign({}, store.identity.user, {
      roles,
      permissions: getPermissions(res.data.map(getChildren)),
    }))
  }), {
    ready: store.identity.isLogined() && res.data != null,
    staleTime: -1,
    cacheTime: -1,
    cacheKey: `/role/user/:id`,
  })

  if (!res.loading) {
    return <Target
      {...props}
      store={store}
      menu={res.data?.slice()}
      theme={themeConfig}
      refreshConstant={() => Promise.resolve(clearCache(`/constant/all`)).then(() => getConstant.runAsync())}
    />
  }

  else {
    return <div className='h-screen flex items-center justify-center bg-gray-800' children={<Spin/>}/>
  }
}
